import { DefaultChatTransport } from 'ai';
import { handleAuthenticatedRequest, addAuthHeader, getToken } from '../../utils/auth';

// AI SDK transport that extends DefaultChatTransport with authentication
export class AuthenticatedChatTransport extends DefaultChatTransport {
  constructor(options = {}) {
    super({
      ...options,
      fetch: async (url, fetchOptions) => {
        const { token } = getToken("access_token");
        
        return handleAuthenticatedRequest(async (refreshedToken) => {
          const authenticatedOptions = {
            ...fetchOptions,
            headers: addAuthHeader(fetchOptions.headers, refreshedToken || token)
          };
          
          return fetch(url, authenticatedOptions);
        });
      }
    });
  }
}

// Authenticated fetch function that the AI SDK can use
export const authenticatedFetch = async (url, options = {}) => {
  // Get current token
  const { token } = getToken("access_token");
  
  // Add auth header if we have a token
  if (token) {
    options.headers = addAuthHeader(options.headers, token);
  }
  
  // Use shared authentication handler for 401 handling
  return handleAuthenticatedRequest(async (refreshedToken) => {
    const fetchOptions = {
      ...options,
      headers: addAuthHeader(options.headers, refreshedToken || token)
    };
    
    return fetch(url, fetchOptions);
  });
};